import { sports } from '../assets/sports'

export const getSportInfos = function (param) {
  let k = Object.keys(param)[0]
  if (k === 'id') {
    for (const sport of sports()) {
      for (const id in sport.id) {
        if (param[k] === sport.id[id]) {
          return sport
        }
      }
    }
  } else if (k === 'federationId') {
    for (const sport of sports()) {
      for (const fid of sport.federationId) {
        if (param[k] === fid) {
          return sport
        }
      }
    }
  } else if (k === 'names') {
    for (const sport of sports()) {
      for (const name in sport.names) {
        if (param[k] === sport.names[name]) {
          return sport
        }
      }
    }
  } else if (k === 'pointNames') {
    for (const sport of sports()) {
      for (const pname in sport.pointNames) {
        if (param[k] === sport.pointNames[pname]) {
          return sport
        }
      }
    }
  } else {
    for (const sport of sports()) {
      if (param[k] === sport[k]) {
        return sport
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/get-sport-infos.js